module.exports = __webpack_public_path__ + "images/emoji/monkey_face.5d9f2e86e02ee628bfb0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/monkey_face.png
// module id = rn8F
// module chunks = 2